import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/workflow-reports/creators/{creatorId}/intake-status';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['params'] & THIS_API['query'] & THIS_API['body'];
type Output = THIS_API['response'];

const getIntakeStatusReport = async ({
  creatorId,
  startDate,
  endDate,
  page = 1,
  perPage = 20,
  workflowStatus,
  initiatedBy,
  paralegal,
  exportCsv,
}: Input): Promise<Output> => {
  const params: THIS_API['query'] = {
    page,
    perPage,
  };

  if (exportCsv !== undefined) {
    params.exportCsv = exportCsv;
  }

  const response = await noodleApiClient.put(
    `/workflow-reports/creators/${creatorId}/intake-status`,
    {
      endDate,
      initiatedBy,
      paralegal,
      startDate,
      workflowStatus,
    },
    {
      params,
    },
  );
  return response.data;
};

export default getIntakeStatusReport;
